export default __webpack_public_path__ + "static/media/MTcarpaFull_Posterior.f725ce13.webp";